import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST';
const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR';
const CLEAR_USER_SEARCH = 'CLEAR_USER_SEARCH';

const initialState = {
	results: [],
	isSearching: false,
	hasError: false,
	error: null,
	lastQuery: '',
};

// Action to search users by email
export const searchUsersByEmail = (query, limit = 10) => (dispatch, getState) => {
	if (!query || query.length < 2) {
		dispatch(clearUserSearch());
		return Promise.resolve();
	}

	const state = getState();
	const url = `${API_URL}/api/users/search?email=${encodeURIComponent(query)}&limit=${limit}`;
	
	dispatch(searchUsersRequest(query));
	
	return get({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: (result) => {
			dispatch(searchUsersSuccess(result, query));
		},
		onError: error => dispatch(searchUsersError(error)),
	});
};

// Clear search results
export const clearUserSearch = () => ({
	type: CLEAR_USER_SEARCH,
});

// Action creators
export const searchUsersRequest = (query) => ({
	type: SEARCH_USERS_REQUEST,
	payload: {
		isSearching: true,
		hasError: false,
		error: null,
		lastQuery: query,
	}
});

export const searchUsersSuccess = (data, query) => ({
	type: SEARCH_USERS_SUCCESS,
	payload: {
		isSearching: false,
		results: data.users || data.data || data,
		hasError: false,
		error: null,
		lastQuery: query,
	}
});

export const searchUsersError = (error) => ({
	type: SEARCH_USERS_ERROR,
	payload: {
		isSearching: false,
		results: [],
		hasError: true,
		error: error,
	}
});

const userSearchReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEARCH_USERS_REQUEST:
		case SEARCH_USERS_SUCCESS:
		case SEARCH_USERS_ERROR:
			return {
				...state,
				...action.payload,
			};
		case CLEAR_USER_SEARCH:
			return initialState;
		default:
			return state;
	}
};

export default userSearchReducer;
